module.exports = __webpack_public_path__ + "static/media/3.f08c7864.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/3.svg
// module id = 2820
// module chunks = 3